import React, { useMemo } from "react";
import { FiShield } from "react-icons/fi";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import { useTheme } from "styled-components";
import {
  BuffersBody,
  BuffersDot,
  BuffersDotCount,
  BuffersDotLabel,
  BuffersLegend,
  BuffersLegendItem,
  CmdCard,
  CmdCardCta,
  CmdCardHeader,
  CmdCardSub,
} from "../styles";

const ZONA_DEFS = [
  { id: "verde", label: "Verde", toneKey: "successBorder" },
  { id: "amarelo", label: "Amarelo", toneKey: "warningBorder" },
  { id: "vermelho", label: "Vermelho", toneKey: "dangerBorder" },
  { id: "preto", label: "Preto", toneKey: "textPrimary" },
];

export default function BuffersCard({ contagemPorZona, onVerCriticos }) {
  const theme = useTheme();

  const data = useMemo(
    () =>
      ZONA_DEFS.map((z) => ({
        id: z.id,
        label: z.label,
        value: contagemPorZona?.[z.id] || 0,
        color: theme[z.toneKey] || theme.border,
      })),
    [contagemPorZona, theme]
  );

  const total = data.reduce((sum, d) => sum + d.value, 0);
  const semDado = contagemPorZona?.semDado || 0;

  return (
    <CmdCard>
      <CmdCardHeader>
        <FiShield size={13} />
        <span>Saúde dos buffers (DBR)</span>
      </CmdCardHeader>
      <CmdCardSub>
        {total} ambiente{total === 1 ? "" : "s"} em fluxo
        {semDado > 0 ? ` · ${semDado} sem dado` : ""}
      </CmdCardSub>
      <BuffersBody>
        <div style={{ position: "relative", width: "100%", height: 110 }}>
          {total > 0 ? (
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={data}
                  dataKey="value"
                  innerRadius={32}
                  outerRadius={52}
                  startAngle={90}
                  endAngle={-270}
                  paddingAngle={1.5}
                  stroke="none"
                  isAnimationActive={false}
                >
                  {data.map((entry) => (
                    <Cell key={entry.id} fill={entry.color} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          ) : (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "grid",
                placeItems: "center",
                color: theme.textSecondary,
                fontSize: 12,
              }}
            >
              Sem dados
            </div>
          )}
        </div>
        <BuffersLegend>
          {data.map((d) => (
            <BuffersLegendItem key={d.id}>
              <BuffersDot $color={d.color} aria-hidden />
              <BuffersDotLabel>{d.label}</BuffersDotLabel>
              <BuffersDotCount>{d.value}</BuffersDotCount>
            </BuffersLegendItem>
          ))}
        </BuffersLegend>
      </BuffersBody>
      {total > 0 && (
        <CmdCardCta type="button" onClick={onVerCriticos}>
          Ver críticos
        </CmdCardCta>
      )}
    </CmdCard>
  );
}
